import { useAppSelector } from '~/store/hooks'
import { SELECTED_ROOF_SECTION_PANEL } from 'store/panel/types'
import Panel, { PanelSection } from 'components/UIKit/Panel'
import { Tab, TabList, Tabs } from '~/ui/Tabs'
import { SelectedRoofSectionProvider } from '~/components/Panels/SelectedRoofSectionPanel/components/SelectedRoofSectionProvider'
import { ColumnsTabPanel } from '~/components/Panels/SelectedRoofSectionPanel/components/ColumnsTabPanel'
import { PrimaryStructuresTabPanel } from '~/components/Panels/SelectedRoofSectionPanel/components/PrimaryStructuresTabPanel'
import { SecondaryStructuresTabPanel } from '~/components/Panels/SelectedRoofSectionPanel/components/SecondaryStructuresTabPanel'
import { TABS } from '~/components/Panels/SelectedRoofSectionPanel/util'

const SelectedRoofSectionPanel = () => {
  const isTouchUI = useAppSelector(it => it.userInterface.isTouchUI)
  return (
    <Panel
      title="Mounting Structures"
      alignment="right"
      docked
      scrollable
      panelKey={SELECTED_ROOF_SECTION_PANEL}
      hasToolbar={isTouchUI}
    >
      <SelectedRoofSectionProvider>
        <PanelSection>
          <Tabs className="gap-2">
            <TabList className="[&>div]:p-1">
              <Tab id={TABS.primary}>Primary</Tab>
              <Tab id={TABS.secondary}>Secondary</Tab>
              <Tab id={TABS.columns}>Columns</Tab>
            </TabList>
            <PrimaryStructuresTabPanel />
            <SecondaryStructuresTabPanel />
            <ColumnsTabPanel />
          </Tabs>
        </PanelSection>
      </SelectedRoofSectionProvider>
    </Panel>
  )
}

export default SelectedRoofSectionPanel
